import { Directive, OnInit, ElementRef, inject, DestroyRef } from "@angular/core";
import { takeUntilDestroyed } from "@angular/core/rxjs-interop";
import { ThemeService } from "../../../core-ui/services";

@Directive({
  selector: "[appThemableLogo]",
  standalone: false,
})
export class ThemableLogoDirective implements OnInit {
  private destroyRef = inject(DestroyRef);
  private themeService = inject(ThemeService);
  private host = inject<ElementRef<HTMLDivElement>>(ElementRef);

  ngOnInit() {
    this.themeService.themeChanged$().pipe(takeUntilDestroyed(this.destroyRef)).subscribe((theme) => {
        const logo = !theme
          ? null
          : !theme.logoUrl
          ? "assets/images/logo_text.svg"
          : theme.logoUrl;

        if (!logo) {
          return;
        }

        this.host.nativeElement.style.backgroundImage = `url(${logo})`;

        // clear previous error (if any)
        this.host.nativeElement.innerHTML = null;

        // check for given logos if the URL actually works
        if (!!theme && theme.logoUrl) {
          const img = document.createElement("img");
          // img.onload = (ev) => {
          //   this.host.nativeElement.innerHTML = null;
          // };
          img.onerror = () => {
            this.host.nativeElement.innerHTML =
              '<av-card type="danger"><av-card-body size="xs">Logo failed to load</av-card-body></av-card>';
          };
          img.src = logo;
        }
      });
  }
}
